import { parseHash } from "~/stores/BuildPageStore";
import { useLocation } from "react-router-dom";

/**
 * Hook for getting the current job logs line number from the URL hash.
 */
export function useLineNumber() {
  const { hash } = useLocation();
  const { line, group } = parseHash(hash) || {};

  return {
    group,
    lineNumber: line ? parseInt(line, 10) : undefined,
  };
}
